import React, { useEffect, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Internal_Audit from "./internal_Audit/Internal_Audit";
import MRM from "./mrm/MRM";
import Risk_Opportunities from "./risk_Opportunities/Risk_Opportunities";
import { GetAll } from "../../../../../../src/features/admin/quality_management/management_system/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Management_requirement = () => {
  const dispatch = useDispatch();
  const nevigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [activeManagementTypeId, setActiveManagementTypeId] = useState(1);

  const managementdetails = useSelector((state) => state.management_system);

  const fetchRecords = async (
    page = 1,
    activeManagementId = activeManagementTypeId,
  ) => {
    if (activeManagementId && activeManagementId !== "") {
      await dispatch(
        GetAll({
          page,
          per_page: managementdetails.per_page,
          management_system_type_id: activeManagementId || 1,
        }),
      );
    }
  };

  // Initial load
  useEffect(() => {
    fetchRecords(currentPage, activeManagementTypeId);
  }, [activeManagementTypeId, currentPage]);

  const [activeTab, setActiveTab] = useState("Internal_Audit");

  const handleTabChange = (key) => {
    setActiveTab(key);

    const tabMapping = {
      Internal_Audit: 1,
      MRM: 2,
      Risk_Opportunities: 3,
    };

    setActiveManagementTypeId(tabMapping[key]);
    setCurrentPage(1);
  };

  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn
          backText="Management System Requirement"
          onClick={() =>
            nevigate("/quality-management/management-system-requirement")
          }
        />
      </div>

      <div className="tables_tab_section">
        <Tab.Container activeKey={activeTab} onSelect={handleTabChange}>
          <Nav variant="pills">
            <Nav.Item>
              <Nav.Link eventKey="Internal_Audit">Internal Audit</Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="MRM">MRM</Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Risk_Opportunities">
                Risk Opportunities
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content className="inner-tab-sec">
            <Tab.Pane eventKey="Internal_Audit">
              <Internal_Audit
                activeManagementTypeId={activeManagementTypeId}
                managementdetails={managementdetails}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="MRM">
              <MRM
                activeManagementTypeId={activeManagementTypeId}
                managementdetails={managementdetails}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="Risk_Opportunities">
              <Risk_Opportunities
                activeManagementTypeId={activeManagementTypeId}
                managementdetails={managementdetails}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </section>
  );
};

export default Management_requirement;
